/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};
const illustration2 = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Hassen OUESLATI",
  title: "Hi all, I'm Hassen OUESLATI",
  subTitle: emoji(
    "Passionate Full Stack Engineer 🚀 with solid experience in building modern web applications using Java, Angular, Spring Boot, Node.js, JavaScript, and TypeScript. Contact Me : oueslatihassen.ing@gmail.com "
  ),
  resumeLink:
    //"https://drive.google.com/file/d/1QfM7wsC92vir6k06LSgwALmQpEr0ifq1/view?usp=sharing", // Set to empty to hide the button old
    //"https://drive.google.com/file/d/1gs134rTrnZyZsALR3eWj8I9xgYDRB21r/view?usp=sharing", // Set to empty to hide the button
    "https://drive.google.com/file/d/1BrJW-SDmiuPbfE4SOJjtuYw0bIXhyW_I/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true ,// Set false to hide this section, defaults to true
  descBullets: [
    "+216 22 615 738",
    "oueslatihassen.ing@gmail.com"
    ],
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/hassenoueslati",
  gitLab: "https://gitlab.com/hassenoueslati",
  linkedin: "https://www.linkedin.com/in/hassen-oueslati-707a7a1b3/",
  gmail: "oueslatihassen.ing@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK AND MAKING THE IMPOSSIBLE POSSIBLE.",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji(
      "⚡ Build powerful and efficient backend systems and APIs for seamless data processing, communication, and integration"
    )
    
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-js" // Icône correcte pour TypeScript
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Spring",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mongoDB",
      fontAwesomeClassname: "fas fa-database"
    },

    {
      skillName: "Html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "Css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    },
   
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "ESPRIT(Private Higher School of Engineering and Technology)",
      logo: require("./assets/images/logoEsprit.jpg"),
      subHeader: "Engineering degree in Computer Science ",
      duration: "September 2020 - September 2023",
      desc: "specialized in web development.",
      descBullets: [
        "ESPRIT is a private higher education institution located in Tunisia. Established in 2003, ESPRIT offers undergraduate and graduate programs in engineering and technology fields."
      ]
    },
    {
      schoolName: "ISETN(Higher Institute of Technology Studies of Nabeul)",
      logo: require("./assets/images/isetn.jpg"),
      subHeader: "National diploma in civil engineering",
      duration: "September 2017 - June 2020",
    },
    {
      schoolName: "Technical High School, Bouarada, Siliana",
      logo: require("./assets/images/ltd.png"),
      subHeader: "Baccalaureate",
      duration: "September 2016 - June 2017",
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    },
    {
      Stack: "DevOps",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Xtensus",
      companylogo: require("./assets/images/xtensus.jpg"),
      date: "13 December 2023 – Present",
      desc: "Full Stack Developer Angular/SpringBoot",
      descBullets: [
        "Contributed to the development of a web application for managing NGOs, covering the entire grant request process from submission to final validation.",
        "Participated in the development of a web application for job office management, focusing on the full recruitment process.",
        "Migrated and restructured a job office management software, transitioning from a monolithic Java JEE architecture to a microservices architecture with Spring and Angular, optimizing performance, security, scalability, and resilience.",
        "Ensured application maintenance by fixing critical bugs and implementing continuous improvements to ensure reliability and availability.",
        "Deployed microservices and new versions on client servers, ensuring smooth integration and stability.",
        "Use of Angular, SpringBoot, MySQL, Keycloak, LDAP, Eureka, Api Geteway, Nginx, Scrum... "

      ]
    },
    {
      role: "Software Engineer (Internship)",
      company: "Wevioo",
      companylogo: require("./assets/images/weviooLogo.png"),
      date: "06 February 2023 – 06 August 2023",
      desc: "Full Stack Developer Angular/SpringBoot",
      descBullets: [
        "Design and development of an electronic document management platform, aimed at optimizing document management and facilitating access to essential information.",
        "Intuitive platform for document download, categorization, advanced search, version management, and archiving.",
        "Secure access management through tokens.",
        "Implementation of real-time notifications for user interaction.",
        "Integration of GitLab pipelines and Docker files for automated deployment.",
        "Use of Angular, SpringBoot, MySQL, Docker, Nginx, Maven, Junit, Nexus, GitLab, Scrum... "
      ],
      footerLink: [
        {
          name: "View demo Dev",
          url: "https://drive.google.com/file/d/1XrlPAXAKrIFhh6TSGMTLHfB4wpmUfED_/view?usp=sharing"
        },
        {
          name: "View demo Ops",
          url: "https://drive.google.com/file/d/1NuesXiyO50LBm0UNNAazcdLJLzmnN5hk/view?usp=sharing"
        },
      ]
    },
    {
      role: "Software Engineer (Internship)",
      company: "TM/Track",
      companylogo: require("./assets/images/tm_track_logo.jpg"),
      date: "15 June 2022 – 31 August 2022",
      desc: "Full Stack Developer Angular/DotNet core",
      descBullets: [
        "Design and development of a web application, Aster Resources, used by the company Aster Resources for its management, especially for candidate recruitment.",
        "Registration, authentication (Facebook, Google)",
        "User management",
        "Job offer management",
        "Candidate management",
        "Use of Angular, DotNet core,PostgreSQL..."
      ]
    },
    {
      role: "Software Engineer (Internship)",
      company: "ESPRIT",
      companylogo: require("./assets/images/logoEsprit.jpg"),
      date: "1 July 2021 – 15 August 2021",
      desc: "Full Stack Developer Angular/SpringBoot",
      descBullets: [
        "Design and development of a web application for project management, for the digitization of projects by categories.",
        "User management",
        "Project management",
        "Category management",
        "Use of Angular, SpringBoot, MySQL, GitHab... "
      ]
    }/*,
    {
      role: "Problem Resolution",
      company: "LeetCode",
      companylogo: require("./assets/images/leetcode.png"),
      date: "January 2023 – Present",
      descBullets: [
        "Multiple Problem Resolution on the LeetCode Platform and Active Pursuit of Programming Skill Development through Continued Work on the Platform",
        "Account Link : https://leetcode.com/oussama_gadria/"
      ]
    }*/
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Academic Projects",
  projects: [
    {
      image: require("./assets/images/eboard3.png"),
      projectName: "E-BOARD",
      projectDesc: "E-BOARD Smart Virtual Classroom is A collaborative web conferencing tool with an online whiteboard, breakout rooms, and screen sharing capabilities for teachers and tutors who want to conduct highly interactive live online teaching sessions.    ",
      descBullets: [
        "User management",
        "Courses management",
        "Stock management",
        "Forum management",
        "Class management",
        "evaluation management",
        "Chat management",
        "Use of MongoDB, ExpressJS, ReactJS, NodeJS, Git, GitHub et Scrum. "
      ],
      footerLink: [
        {
          name: "View Demo",
          url: "https://drive.google.com/file/d/1-65wH_VpaawBMR5aE38bC855zWU5Fo9a/view?usp=sharing"
        },
        {
          name: "Github Repo",
          url: "https://github.com/hassenoueslati/Eboard"
        }
      ]
    },
    {
      image: require("./assets/images/devOps3.png"),
      projectName: "DevOps Project",
      projectDesc: "Setting up a Jenkins CI/CD pipeline for a spring boot web application ",
      descBullets: [
        "Jenkins automates compiling, testing, deploying.",
        "Maven ensures consistent Java builds.",
        "Nexus manages Maven artifacts for distribution.",
        "JUnit validates code quality.",
        "SonarQube checks for vulnerabilities.",
        "Docker containerizes apps.",
        "Prometheus gathers app data.",
        "Grafana visualizes performance.",
        "Docker Compose orchestrates test environments."


      ],
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/hassenoueslati/tpAchatAeroDev"
        }
      ]
    },
    {
      image: require("./assets/images/agence.png"),
      projectName: "Microservices Project",
      projectDesc: "Design and Development of a web application for a travel agency based on microservices architecture",
      descBullets: [
        "Flight management",
        "Reservation Management",
        "Offer Management",
        "Partner Management",
        "Use of Spring Boot, Angular, MySQL, H2, MongoDB, Docker, Eureka and GitHub. "
      ],
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/hassenoueslati/AganceVoyageMicroServiceAeroDev"
        }
      ]
    },
    {
      image: require("./assets/images/store.png"),
      projectName: "Store Management",
      projectDesc: "Design and Development of a web application for a store.",
      descBullets: [
        "User management",
        "Product management",
        "Stock management",
        "Supplier management",
        "Bill management",
        "claim management",
        "Use of Angular, SpringBoot, MySQL and GitHab. "
      ],
      footerLink: [
        {
          name: "Github Client Repo",
          url: "https://github.com/hassenoueslati/MagasinFrontEnd-Angular"
        },
        {
          name: "Github Server Repo",
          url: "https://github.com/hassenoueslati/MagasinBackEnd-Spring"
        }
      ]
    },
    {
      image: require("./assets/images/smartFarm.png"),
      projectName: "SmartFarm",
      projectDesc: "SmartFarm is a solution allowing a digital management of the different activities of a farm",
      footerLink: [
        {
          name: "View Demo",
          url: "https://drive.google.com/file/d/143cmD0EsY6TVy8pWnE8HgnJ9lYciDkXa/view?usp=sharing"
        },
        {
          name: "Github Repo",
          url: "https://github.com/hassenoueslati/SmartFarmApp"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};



//small project 
const smallProjects = {
  title: "Small Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE Some Components",
  projects: [
    {
      image: require("./assets/images/feedback.png"),
      projectName: "FeedBack Component",
      projectDesc: "• This app features a responsive design that adjusts to different screen sizes, providing an optimal layout. Interactive elements have hover states, enhancing user experience. Users can submit feedback ratings and receive a Thank you confirmation after submission.    ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://feedback-jade.vercel.app"
        }
      ]
    },
    {
      image: require("./assets/images/country.jpg"),
      projectName: "Country App",
      projectDesc: "Explore the world with our responsive country app built using React.js and powered by Vite and Tailwind CSS. Enjoy intuitive interactions and discover fascinating information about different countries. Dive into a seamless user experience and embark on an adventure of exploration and learning. Start your journey today and unlock the wonders of the world at your fingertips.  ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://countries-app-seven-omega.vercel.app"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};
// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji(" Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Scrum Fundamentals Certified",

      image: require("./assets/images/scrum.PNG"),
      imageAlt: "Scrum Fundamentals Certified",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.scrumstudy.com/certification/verify?type=SFC&number=1064067"
        },

      ]
    },
    {
      title: "HTML",
     
      image: require("./assets/images/htmlHassen.png"),
      imageAlt: "HTML",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.sololearn.com/certificates/CT-4HEESMDX"
        },
       
      ]
    },
    {
      title: "SQL",
      image: require("./assets/images/sqlhassen.png"),
      imageAlt: "SQL",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.sololearn.com/certificates/CT-FGZPCU0F"
        }
      ]
    },
    /*{
      title: "Git & Github ",
      image: require("./assets/images/udemy.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-cd611a25-5119-4f38-a2b6-7187a99d5ac9/"
        }
      ]
    },*/
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  
};

// Talks Sections

const talkSection = {
 
};

// Podcast Section

const podcastSection = {
 
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? Contact Me : +216 22 615 738 ",
  
    
};

// Twitter Section

const twitterDetails = {
  
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  illustration2,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  smallProjects
};
